"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCharExist = exports.letterCount = exports.setCharAt = void 0;
function setCharAt(str, index, chr) {
    if (index > str.length - 1)
        return str;
    return str.substring(0, index) + chr + str.substring(index + 1);
}
exports.setCharAt = setCharAt;
function letterCount(str, letter) {
    if (!str)
        return 0;
    return str.split("").reduce((acc, ch) => (ch === letter ? acc + 1 : acc), 0);
}
exports.letterCount = letterCount;
function isCharExist(str, subStrArr) {
    if (!str)
        return 0;
    let y = 0;
    let bool = false;
    while (y < subStrArr.length) {
        if (typeof subStrArr[y] == "number" || typeof subStrArr[y] == "string") {
            if (str.includes(subStrArr[y])) {
                bool = true;
                break;
            }
        }
        else {
            const regex = subStrArr[y];
            if (regex.test(str)) {
                bool = true;
            }
        }
        y++;
    }
    return bool ? true : false;
}
exports.isCharExist = isCharExist;
